
import { defineComponent } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'

const ZONES = [
    { id: 1, name: 'Зона 1' },
    { id: 2, name: 'Зона 2' },
    { id: 3, name: 'Зона 3' },
    { id: 4, name: 'Зона 4' },
    { id: 5, name: 'Зона 5' },
    { id: 6, name: 'Зона 6' },
    { id: 7, name: 'Зона 7' },
]

export default defineComponent({
    components: {
        TheButton,
    },
    props: {
        value: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change', 'open-modal'],
    setup(props, { emit }) {
        const updateValue = (value: number) => {
            if (props.value === value || props.disabled) return

            emit('update:value', value)
            emit('change', value)
        }

        const openModal = () => {
            emit('open-modal')
        }

        return {
            ZONES,
            updateValue,
            openModal,
        }
    },
})
